export default "__VITE_ASSET__BQxmwwx8__"